export default {"src":"/_next/static/media/twitter-round.aecce8ba.svg","height":50,"width":50};